"use strict";
/*
 * Created on 08 26 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Site_1 = require("./Site");
/**
 * <p>
 *     This entity represents warehouse of type stock. You may say that it is special type of {@link InternalSite}, but we model it as
 *     independent entity. It is planned to use different repository to store them.
 * </p>
 *
 * @author JMe
 */


var Stock =
/*#__PURE__*/
function (_Site_1$Site) {
  _inherits(Stock, _Site_1$Site);

  /**
   * Ctor.
   *
   * @param id internal id of entity
   * @param externalId external id
   * @param name name
   */
  function Stock(id, externalId, name) {
    var _this;

    _classCallCheck(this, Stock);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stock).call(this, id, externalId, null, null, null, null));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    return _this;
  }

  return Stock;
}(Site_1.Site);

exports.Stock = Stock;